// extracted by mini-css-extract-plugin
export default {"charts":"Style_charts__2Q+-v","title":"Style_title__SSbJA"};